import { render, staticRenderFns } from "./CurriculumUnitsAligned.vue?vue&type=template&id=4e06f63e&scoped=true&lang=pug&"
import script from "./CurriculumUnitsAligned.vue?vue&type=script&lang=ts&"
export * from "./CurriculumUnitsAligned.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumUnitsAligned.vue?vue&type=style&index=0&id=4e06f63e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06f63e",
  null
  
)

export default component.exports